module.exports = __webpack_public_path__ + "static/img/red-envelope-bottom.1c95247.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/alipay/red-envelope-bottom.png
// module id = L7S0
// module chunks = 1